import React from 'react';
import styles from "./Manageclients.module.scss";
import CustomButton from '../../components/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useClientBulkUpload } from '../../utils/hooks/Client/Bulk-upload';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export default function ModalContent() {
    const { bulkUploadData, setBulkUploadData } = useClientBulkUpload();

    const base64Data = bulkUploadData.storeCsvFile;
    // Decode base64 string to binary data
    const binaryData = atob(base64Data);

    // Convert binary data to string (CSV content)
    const csvContent = binaryData;

    const handleCsvDownload = () => {
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = 'filename.csv'; // Set desired file name
        downloadLink.click();
    };

    return (
        <>
            <div className={styles.bulkUploadModalContainer}>
                <ErrorIcon sx={{ fontSize: "80px", color: "#f00" }} />
                <h1>Some clients and contacts are not added. Download the <span>rejected list</span> to reupload.</h1>
            </div>
            <div className={styles.modalBtnWrapper}>
                <CustomButton onClick={() => {
                    setBulkUploadData((prevState) => ({
                        ...prevState,
                        showBulkUploadModal: false
                    }))
                }}>Close</CustomButton>
                <CustomButton onClick={handleCsvDownload}>
                    Download Rejected List <ArrowRightAltIcon />
                </CustomButton>
            </div>
        </>
    )
}
